export default {
      id: "route-usage",
      viewBox: "0 0 512 512",
      url: __webpack_public_path__ + "img/icons.845ff42f.svg#route",
      toString: function () {
        return this.url;
      }
    }